import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { Form, InputGroup } from "@themesberg/react-bootstrap";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { faCalendarAlt } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const DatePickerComponent = forwardRef((props, ref) => {
  const datePickerRef = useRef(null);

  useImperativeHandle(ref, () => ({
    setOpen: (value) => {
      datePickerRef.current.setOpen(value);
    },
  }));

  const CustomInput = forwardRef(({ value, onClick, onChange }, ref) => (
    <InputGroup>
      <InputGroup.Text>
        <FontAwesomeIcon icon={faCalendarAlt} />
      </InputGroup.Text>
      <Form.Control
        ref={ref}
        required={props.mandatory}
        type="text"
        placeholder="Pilih Tanggal"
        onChange={onChange}
        value={value}
        onClick={onClick}
        disabled={props.formDisable}
        readOnly
        style={{
          backgroundColor: "#FFFFFF",
        }}
      />
    </InputGroup>
  ));

  function isValidDate(dateString) {
    const date = new Date(dateString);



    // Check if the date is a valid date and not equal to NaN
    return !isNaN(date.getTime()) ? date : null;
  }

  return (
    <DatePicker
      ref={datePickerRef}
      selected={isValidDate(props.value)} // Setel tanggal yang dipilih (gunakan null jika ingin default kosong)
      onChange={(e) => props.onChange(e)}
      value={isValidDate(props.value)}
      dateFormat="dd/MM/yyyy"
      selectsStart={props.selectsStart}
      selectsEnd={props.selectsEnd}
      selectsRange={props.selectsRange}
      startDate={isValidDate(props.startDate)}
      minDate={isValidDate(props.minDate)}
      endDate={isValidDate(props.endDate)}
      maxDate={isValidDate(props.maxDate)}
      disabled={props.formDisable}
      customInput={<CustomInput ref={ref} />}
    />
  );
});

export default DatePickerComponent;
